import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';

export const RoutineDetailPageSkeleton: React.FC = () => {
  return (
    <>
      <Box sx={{ py: 5, borderBottom: 1, borderColor: 'divider' }} className="container-fluid">
        <Box>
          <Skeleton variant="rectangular" height="2.5rem" sx={{ mb: 1 }} width="min(35rem, 100%)" />
          <Grid container flexDirection="column" spacing={1.5}>
            <Grid item>
              <Skeleton variant="text" width="max(7.5rem, 20vw)" />
              <Skeleton variant="text" width="max(7.5rem, 20vw)" />
            </Grid>
            <Grid item>
              <Grid container alignItems="center" flexWrap="nowrap" spacing={1}>
                <Grid item>
                  <Skeleton variant="circular" height="4rem" width="4rem" />
                </Grid>
                <Grid item xs>
                  <Skeleton variant="rectangular" height="1.5rem" width="15rem" />
                  <Skeleton variant="text" width="10rem" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Skeleton sx={{ mt: 3 }} variant="rectangular" height="3rem" width="9rem" />
      </Box>
    </>
  );
};
